module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15wJlxw/tc-custom/9781426805837.jpg?1718183630833",
      "alt": "This image is the cover for the book Blown Away"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blown Away\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Overseas, TJ Barton narrowly survived an American Embassybombing, only to lose two good men: her influential bossand her lover, Sean McNeal."), _c('br'), _c('br'), _vm._v("Back in Washington, TJ set out to find out who did it. Undaunted,she maneuvered through corridors of power, exposing thesecrets hidden behind every door on Capitol Hillonly to smackright into the broad, "), _c('i', [_vm._v("familiar")]), _vm._v(" chest of Sean McNealin the flesh. And she could have, would have decked him if she had theopportunity to get a good shot!"), _c('br'), _c('br'), _vm._v("Inexplicably Sean had survived and was now undercover. Heneeded TJ's silence, her help and her kisses more than hewanted to admit. The last thing he wanted to do was draw TJinto a web of high-stakes corruption. But there was noshaking her off and there was no way she wasgoing to let him get killedagain.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elle James\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Raised an Air Force brat, Elle James got her work ethic from her dad, creativity from mom and inspiration from her sister. As a member of the reserves, she's traveled, managed a career, and raised three children. She and her husband even raised ostriches and emus. Ask her what it's like to go toe-to-toe with a 350-pound bird! Former manager of computer programmers, Elle is happy to write full time in NW Arkansas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0